import React from 'react';
import ClerkSignUp from './ClerkSignUp';
import AuthTemplate from '../../common/auth-template/AuthTemplate';
import FeatureItems from '../../common/feature-items/FeatureItems';

const SignUp = () => {
  return <AuthTemplate featureItems={<FeatureItems />}>{<ClerkSignUp />}</AuthTemplate>;
};

export default SignUp;
